import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ChevronDown } from '@outdoor-voices/ui';
import { useEffect, useRef, useState } from 'react';
import cc from 'classcat';
import { BANNER_HEIGHT, TEXT } from '../../config/constants';
import { HERO_DESKTOP, HERO_MOBILE } from './constants';
import css from './Hero.module.scss';
import UGC from '../../components/UGC';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Hero = function Hero() {
  var _cls;

  var rootRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      wordsOn = _useState2[0],
      setWordsOn = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      wordsOff = _useState4[0],
      setWordsOff = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      enabled = _useState6[0],
      setEnabled = _useState6[1];

  useEffect(function () {
    setTimeout(function () {
      setWordsOn(true);
    }, 500);
    setTimeout(function () {
      setWordsOff(true);
    }, 2500);
    setTimeout(function () {
      setEnabled(true);
    }, 4500);
  }, []);
  var cls = (_cls = {}, _defineProperty(_cls, css.on, wordsOn), _defineProperty(_cls, css.off, wordsOff), _cls);

  var scrollToContent = function scrollToContent() {
    var rootEl = rootRef.current;

    if (!rootEl) {
      return false;
    }

    var top = rootEl.offsetHeight + BANNER_HEIGHT;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
    return true;
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    ref: rootRef,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.words,
      children: [/*#__PURE__*/_jsx("div", {
        className: cc([css.word, css.hey, cls]),
        children: "Hey,"
      }), /*#__PURE__*/_jsx("div", {
        className: cc([css.word, css.hi, cls]),
        children: "Hi,"
      }), /*#__PURE__*/_jsx("div", {
        className: cc([css.word, css.hello, cls]),
        children: "Hello"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.image, _defineProperty({}, css.on, wordsOff)]),
      style: {
        aspectRatio: "".concat(HERO_DESKTOP.image.width, " / ").concat(HERO_DESKTOP.image.height)
      },
      children: /*#__PURE__*/_jsx(UGC, {
        enabled: enabled,
        image: HERO_DESKTOP.image,
        instagramProducts: HERO_DESKTOP.products
      })
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.image, css.mobile, _defineProperty({}, css.on, wordsOff)]),
      style: {
        aspectRatio: "".concat(HERO_MOBILE.image.width, " / ").concat(HERO_MOBILE.image.height)
      },
      children: /*#__PURE__*/_jsx(UGC, {
        enabled: enabled,
        image: HERO_MOBILE.image,
        instagramProducts: HERO_MOBILE.products
      })
    }), /*#__PURE__*/_jsx("div", {
      className: css.inner,
      children: /*#__PURE__*/_jsxs("div", {
        className: css.titleWrap,
        children: [/*#__PURE__*/_jsx("h1", {
          className: cc([css.title, _defineProperty({}, css.on, wordsOff)]),
          children: "Welcome to Our Playground."
        }), /*#__PURE__*/_jsxs("button", {
          "aria-label": TEXT.scrollDown,
          className: css.jumper,
          onClick: scrollToContent,
          type: "button",
          children: ["Explore", /*#__PURE__*/_jsx(ChevronDown, {})]
        })]
      })
    })]
  });
};

export default Hero;